import React from "react";
import PopoverDropdownMenu from "../../../../Menus/PopoverDropdownMenu";
import DropdownOptionWithIcon from "../../../../Menus/DropdownOptionWithIcon";
import { Field } from "../../../../../types/TenantInterfaces";
import { FormBuilder } from "../../../../../types/FormBuilderInterfaces";

interface Props {
  form: FormBuilder;
  setForm: (value: any, key: string) => void;
  field: Field;
}

const FieldsOptions = ({ form, setForm, field }: Props) => {
  const handleRemoveField = () => {
    delete form.Fields?.[field.APIName];
    const newFields = form.Fields;
    setForm(newFields, "fields");
  };

  const options = [
    {
      key: "remove",
      name: "Remove Field",
      icon: "mdi mdi-delete",
      onClick: () => handleRemoveField(),
    },
  ] as const;

  return (
    <PopoverDropdownMenu>
      {options.map((option) => {
        return (
          // @ts-ignore
          <DropdownOptionWithIcon
            key={option.key}
            name={option.name}
            icon={option.icon}
            onClick={option.onClick}
          ></DropdownOptionWithIcon>
        );
      })}
    </PopoverDropdownMenu>
  );
};

export default FieldsOptions;
